import { ShareState } from '@context/useShareContext/types';
import { serviceContext$ } from '@pages/AdditionalServices/containers/bus';

import { SetUpServiceData } from '../../basket/types';
import { clone } from '../../clone';
import { restoreAdditionalServiceState } from '../restoreAdditionalServiceState';

/**
 * shortLinkApproach проверяет тип восстанавливаемых данных. Если
 * восстанавливаются не доп. услуги сбрасывает флаг и останавливает
 * процесс, если доп. услуги запускает восстановление.
 *
 * @param data
 * @param langID
 * @param currencyID
 */
export const shortLinkApproach = async (data: ShareState, langID: string, currencyID: string) => {
  const state = clone(serviceContext$.getValue());
  const setUpServiceDataIndex = (data.ShareData ?? []).findIndex(
    (service: SetUpServiceData) => !!service?.IsSetupService
  );

  if (data.ShareType === 'delivery' || setUpServiceDataIndex === -1) {
    serviceContext$.next({
      ...state,
      IsRestoringState: false,
    });
    return;
  }

  const otherServices = data.ShareData.slice();
  otherServices.splice(setUpServiceDataIndex, 1);

  restoreAdditionalServiceState(
    data.ShareData[setUpServiceDataIndex],
    otherServices,
    langID,
    currencyID
  );
};
